const buildRegistryRow = ({
  action,
  label,
  bucket,
  scope,
  visibleIn = [],
  appearsInProductionPopup = false,
  appearsInProjectNotes = false,
  appearsInCustomerNotes = false,
  appearsInFinance = false,
  description = "",
  foundIn = [],
}) => ({
  action,
  label,
  bucket,
  scope,
  visibleIn,
  appearsInProductionPopup,
  appearsInProjectNotes,
  appearsInCustomerNotes,
  appearsInFinance,
  description,
  foundIn,
});

export const isInboundProjectEmailNote = (note = {}) => {
  const action = String(note?.action || "").trim().toLowerCase();
  const scope = String(note?.scope || "").trim().toLowerCase();
  return action === "inbound-project-email" || scope === "project-email";
};

export const NOTE_ACTION_REGISTRY = [
  buildRegistryRow({
    action: "lead-create",
    label: "Lead Created",
    bucket: "sales",
    scope: "lead",
    visibleIn: ["sales", "customer-notes"],
    appearsInCustomerNotes: true,
    description: "Lead/customer record was created from intake or CRM activity.",
    foundIn: ["server/routes/Customers.js"],
  }),
  buildRegistryRow({
    action: "lead-update",
    label: "Lead Updated",
    bucket: "sales",
    scope: "lead",
    visibleIn: ["sales", "customer-notes"],
    appearsInCustomerNotes: true,
    description: "Lead/customer intake details were updated.",
    foundIn: ["server/routes/Customers.js"],
  }),
  buildRegistryRow({
    action: "ai-lead-assignment",
    label: "AI Lead Assignment",
    bucket: "sales",
    scope: "lead",
    visibleIn: ["sales", "customer-notes"],
    appearsInCustomerNotes: true,
    description: "AI assigned a lead to a rep.",
    foundIn: ["server/routes/Customers.js"],
  }),
  buildRegistryRow({
    action: "assignment",
    label: "Assignment",
    bucket: "sales",
    scope: "assignment",
    visibleIn: ["sales", "customer-notes"],
    appearsInCustomerNotes: true,
    description: "Customer assignment changed.",
    foundIn: ["server/routes/Customers.js"],
  }),
  buildRegistryRow({
    action: "cart-presentation-generated",
    label: "Presentation Generated",
    bucket: "sales",
    scope: "presentation",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation document was generated from the cart.",
    foundIn: [
      "server/routes/Presentation.js",
      "server/services/crm/orderTransition.service.js",
    ],
  }),
  buildRegistryRow({
    action: "cart-presentation-regenerated",
    label: "Presentation Regenerated",
    bucket: "sales",
    scope: "presentation",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation snapshot was refreshed from the current cart.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "presentation-update",
    label: "Presentation Updated",
    bucket: "sales",
    scope: "presentation",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation metadata or settings were updated.",
    foundIn: ["server/routes/Presentation.js"],
  }),
  buildRegistryRow({
    action: "presentation-comment",
    label: "Presentation Comment",
    bucket: "sales",
    scope: "presentation",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "A comment was added to a presentation item.",
    foundIn: ["server/routes/PresentationComment.js"],
  }),
  buildRegistryRow({
    action: "presentation-sent",
    label: "Presentation Sent",
    bucket: "sales",
    scope: "presentation-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation email was sent to the client.",
    foundIn: ["server/routes/Presentation.js"],
  }),
  buildRegistryRow({
    action: "presentation-resent",
    label: "Presentation Resent",
    bucket: "sales",
    scope: "presentation-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation email was resent.",
    foundIn: ["server/routes/Presentation.js"],
  }),
  buildRegistryRow({
    action: "presentation-email-simulated",
    label: "Presentation Email Simulated",
    bucket: "sales",
    scope: "presentation-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation email send was simulated.",
    foundIn: ["server/routes/Presentation.js"],
  }),
  buildRegistryRow({
    action: "presentation-email-resend-simulated",
    label: "Presentation Email Resend Simulated",
    bucket: "sales",
    scope: "presentation-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Presentation resend was simulated.",
    foundIn: ["server/routes/Presentation.js"],
  }),
  buildRegistryRow({
    action: "cart-estimate-generated",
    label: "Estimate Generated",
    bucket: "sales",
    scope: "estimate",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate document was generated from the cart.",
    foundIn: [
      "server/controller/estimations.js",
      "server/services/crm/orderTransition.service.js",
    ],
  }),
  buildRegistryRow({
    action: "cart-estimate-snapshot-refreshed",
    label: "Estimate Snapshot Refreshed",
    bucket: "sales",
    scope: "estimate",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate snapshot was regenerated from the current cart.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "cart-sales-order-generated",
    label: "Sales Order Generated",
    bucket: "sales",
    scope: "sales-order",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Sales order document was generated from the cart.",
    foundIn: [
      "server/controller/estimations.js",
      "server/services/crm/orderTransition.service.js",
    ],
  }),
  buildRegistryRow({
    action: "cart-sales-order-snapshot-refreshed",
    label: "Sales Order Snapshot Refreshed",
    bucket: "sales",
    scope: "sales-order",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Sales order snapshot was regenerated from the current cart.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "estimate-email-sent",
    label: "Estimate Email Sent",
    bucket: "sales",
    scope: "estimate-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate email was sent from the estimate generation flow.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "sales-doc-email-sent",
    label: "Sales Document Email Sent",
    bucket: "sales",
    scope: "sales-document-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate or sales order email was sent.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "sales-doc-email-simulated",
    label: "Sales Document Email Simulated",
    bucket: "sales",
    scope: "sales-document-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate or sales order email send was simulated.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "sales-doc-email-resent",
    label: "Sales Document Email Resent",
    bucket: "sales",
    scope: "sales-document-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate or sales order email was resent.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "sales-doc-email-resend-simulated",
    label: "Sales Document Email Resend Simulated",
    bucket: "sales",
    scope: "sales-document-email",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Estimate or sales order resend was simulated.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "product-comment",
    label: "Product Comment",
    bucket: "sales",
    scope: "product-comment",
    visibleIn: ["project-notes", "sales"],
    appearsInProjectNotes: true,
    description: "Comment was added to a product while working a sales document.",
    foundIn: ["server/controller/estimations.js"],
  }),
  buildRegistryRow({
    action: "written-project-note",
    label: "Written Project Note",
    bucket: "project",
    scope: "project",
    visibleIn: ["project-notes", "customer-notes"],
    appearsInProjectNotes: true,
    appearsInCustomerNotes: true,
    description: "General project note written by a user or system flow.",
    foundIn: [
      "server/routes/Customers.js",
      "server/controller/chatController.js",
    ],
  }),
  buildRegistryRow({
    action: "production-completion-update",
    label: "Production Completion Update",
    bucket: "production",
    scope: "production",
    visibleIn: ["production-popup", "project-notes", "customer-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    appearsInCustomerNotes: true,
    description: "Production system note when a department completes work or all production requirements are complete.",
    foundIn: ["server/routes/production/productionorder.js"],
  }),
  buildRegistryRow({
    action: "inbound-project-email",
    label: "Email Received",
    bucket: "project",
    scope: "project-email",
    visibleIn: ["production-popup", "project-notes", "customer-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    appearsInCustomerNotes: true,
    description: "Inbound email to a project address was captured as a note and remains visible in scoped purchasing production activity.",
    foundIn: ["server/services/inboundEmail/handlers/projectNote.js"],
  }),
  buildRegistryRow({
    action: "order-create",
    label: "Order Created",
    bucket: "project",
    scope: "order",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "Order/project record was created.",
    foundIn: ["server/routes/Operations.js"],
  }),
  buildRegistryRow({
    action: "order-update",
    label: "Order Updated",
    bucket: "project",
    scope: "order",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "Order/project record was updated.",
    foundIn: ["server/routes/Operations.js"],
  }),
  buildRegistryRow({
    action: "order-create-congrats",
    label: "Order Create Congrats",
    bucket: "project",
    scope: "order",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "Automatic congratulations note when a project is created.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "cart-updated",
    label: "Cart Updated",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "Project cart items were added, updated, or removed.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "cart-item-updated",
    label: "Cart Item Updated",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "A single cart item was updated.",
    foundIn: ["server/routes/OrderItems.js"],
  }),
  buildRegistryRow({
    action: "cart-item-removed",
    label: "Cart Item Removed",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "A single cart item was removed.",
    foundIn: ["server/routes/OrderItems.js"],
  }),
  buildRegistryRow({
    action: "cart-other-service-added",
    label: "Other Service Added",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "An order other-service row was added.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "cart-other-service-updated",
    label: "Other Service Updated",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "An order other-service row was updated.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "cart-other-service-deleted",
    label: "Other Service Deleted",
    bucket: "project",
    scope: "cart",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "An order other-service row was deleted.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "project-overview-updated",
    label: "Project Overview Updated",
    bucket: "project",
    scope: "project-overview",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "Project overview status metadata changed.",
    foundIn: ["server/routes/Orders.js"],
  }),
  buildRegistryRow({
    action: "update",
    label: "Update",
    bucket: "project",
    scope: "update",
    visibleIn: ["project-notes", "customer-notes"],
    appearsInProjectNotes: true,
    appearsInCustomerNotes: true,
    description: "Generic update note reused by customer updates, project assignment updates, and sales order edits.",
    foundIn: [
      "server/routes/Customers.js",
      "server/routes/Orders.js",
      "server/controller/estimations.js",
    ],
  }),
  buildRegistryRow({
    action: "sent-email",
    label: "Email Sent",
    bucket: "customer",
    scope: "customer-email",
    visibleIn: ["customer-notes"],
    appearsInCustomerNotes: true,
    description: "Manual customer email was sent from the customer workflow.",
    foundIn: ["server/routes/Customers.js"],
  }),
  buildRegistryRow({
    action: "insightly-prospect-conversion",
    label: "Insightly Prospect Conversion",
    bucket: "customer",
    scope: "crm",
    visibleIn: ["customer-notes", "sales"],
    appearsInCustomerNotes: true,
    description: "Insightly lead/prospect was linked or converted into a customer record.",
    foundIn: ["server/services/crm/prospectConversion.service.js"],
  }),
  buildRegistryRow({
    action: "new-invoice",
    label: "Invoice Created",
    bucket: "finance",
    scope: "invoice",
    visibleIn: ["finance", "project-notes"],
    appearsInProjectNotes: true,
    appearsInFinance: true,
    description: "Invoice creation note appended to the project.",
    foundIn: ["server/controller/invoice.js"],
  }),
  buildRegistryRow({
    action: "invoice-sent",
    label: "Invoice Email Sent",
    bucket: "finance",
    scope: "invoice",
    visibleIn: ["finance", "project-notes"],
    appearsInProjectNotes: true,
    appearsInFinance: true,
    description: "Provider-accepted invoice email recorded with invoice ID, recipient list and timestamp.",
    foundIn: ["server/services/invoiceEmailHistory.js"],
  }),
  buildRegistryRow({
    action: "deposit-paid",
    label: "Deposit Paid",
    bucket: "finance",
    scope: "payment",
    visibleIn: ["finance", "project-notes"],
    appearsInProjectNotes: true,
    appearsInFinance: true,
    description: "Stripe deposit payment was reconciled to the project.",
    foundIn: ["server/utils/stripeDepositReconcile.js"],
  }),
  buildRegistryRow({
    action: "production-next-action-date",
    label: "Production Next Action / Date",
    bucket: "production",
    scope: "purchasing",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "PO next action or next action date note added from the purchasing UI.",
    foundIn: ["client/src/components/PurchaseOrder/PurchaseOrderList/PurchaseOrderTable/index.js"],
  }),
  buildRegistryRow({
    action: "po-lifecycle-status-change",
    label: "Purchase Order Status Changed",
    bucket: "production",
    scope: "purchasing",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "A user manually changed a purchase order lifecycle status.",
    foundIn: ["server/services/purchasingStatusNotes.js"],
  }),
  buildRegistryRow({
    action: "po-status-change",
    label: "Purchasing Status Changed",
    bucket: "production",
    scope: "purchasing",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "A user changed a PO's Problem / OK / Follow Up purchasing status.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "purchasing-note",
    label: "Purchasing Note",
    bucket: "production",
    scope: "purchasing",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Reply note inside the purchasing/production note thread.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "purchase-order-create",
    label: "Purchase Order Created",
    bucket: "production",
    scope: "purchase-order",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Purchase order was created for the project.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "shipping-update",
    label: "Shipping Update",
    bucket: "production",
    scope: "shipping",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Shipping-related update was posted from the PO flow.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proofs-all-approved",
    label: "All Proofs Approved",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "All proofs for a PO were approved.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-designer-notify",
    label: "Proof Designer Notify",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Designer was notified about a proof workflow step.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-reused",
    label: "Proof Reused",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "An existing proof was reused for the PO.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proofs-sent-bundle",
    label: "Proofs Sent Bundle",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "A proof bundle was sent out.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-designer-assign",
    label: "Proof Designer Assigned",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "A designer was assigned to the proof.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-internal-approve",
    label: "Proof Internal Approved",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Internal team approved a proof.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-client-approve",
    label: "Proof Client Approved",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Client approved a proof.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-internal-reject",
    label: "Proof Internal Rejected",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Internal team rejected a proof.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "proof-client-reject",
    label: "Proof Client Rejected",
    bucket: "production",
    scope: "proofs",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Client rejected a proof or requested changes.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "po-receipt-saved",
    label: "PO Receipt Saved",
    bucket: "production",
    scope: "receiving",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Warehouse/receiving saved a PO receipt update.",
    foundIn: ["server/controller/shippingWarehouse.js"],
  }),
  buildRegistryRow({
    action: "so-auto-in-production",
    label: "Sales Order Auto In Production",
    bucket: "production",
    scope: "production",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "Sales order automatically moved into production after PO creation.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "supplier-email-sent",
    label: "Supplier PO Sent",
    bucket: "production",
    scope: "supplier-email",
    visibleIn: ["production-popup", "project-notes"],
    appearsInProductionPopup: true,
    appearsInProjectNotes: true,
    description: "A purchase order email was successfully sent to the supplier with the exact generated PDF revision attached.",
    foundIn: ["server/controller/purchaseOrder.js"],
  }),
  buildRegistryRow({
    action: "chat-digest",
    label: "Chat Digest",
    bucket: "system",
    scope: "chat",
    visibleIn: ["project-notes"],
    appearsInProjectNotes: true,
    description: "System-generated live chat digest note.",
    foundIn: ["server/services/chatDigest.js"],
  }),
  buildRegistryRow({
    action: "ezee-growth-followup-sent",
    label: "Ezee Growth Follow-Up Sent",
    bucket: "sales",
    scope: "growth",
    visibleIn: ["customer-notes", "sales"],
    appearsInCustomerNotes: true,
    description: "Confirmed Ezee Growth customer follow-up email was sent and attributed to a Growth opportunity.",
    foundIn: ["server/services/ai/growthFollowupComposerService.js"],
  }),
  buildRegistryRow({
    action: "ezee-growth-activity-created",
    label: "Ezee Growth Activity Created",
    bucket: "sales",
    scope: "growth",
    visibleIn: ["customer-notes", "sales"],
    appearsInCustomerNotes: true,
    description: "Confirmed Ezee Growth CRM follow-up activity was created for a Growth opportunity.",
    foundIn: ["server/services/ai/growthFollowupComposerService.js"],
  }),
  buildRegistryRow({
    action: "ai-followup",
    label: "AI Follow-Up",
    bucket: "system",
    scope: "automation",
    visibleIn: ["customer-notes"],
    appearsInCustomerNotes: true,
    description: "AI lifecycle follow-up completed for a customer.",
    foundIn: ["server/workers/aiDbWorker.js"],
  }),
  buildRegistryRow({
    action: "ai-task",
    label: "AI Task",
    bucket: "system",
    scope: "automation",
    visibleIn: ["customer-notes"],
    appearsInCustomerNotes: true,
    description: "AI-created task note was written to customer history.",
    foundIn: ["server/workers/aiDbWorker.js", "server/routes/AI.js"],
  }),
  buildRegistryRow({
    action: "ai-draft",
    label: "AI Draft Approved",
    bucket: "system",
    scope: "automation",
    visibleIn: ["customer-notes"],
    appearsInCustomerNotes: true,
    description: "Approved AI draft note was written to customer history.",
    foundIn: ["server/routes/AI.js"],
  }),
];

export const getNoteActionDefinition = (action) =>
  NOTE_ACTION_REGISTRY.find((row) => row.action === action) || null;

export const getNoteRegistryRows = () =>
  NOTE_ACTION_REGISTRY.map((row) => ({
    ...row,
    visibleIn: [...row.visibleIn],
    foundIn: [...row.foundIn],
  }));

export const getNoteVisibleAreas = (action) =>
  getNoteActionDefinition(action)?.visibleIn || [];

export const isProductionRegistryAction = (action) =>
  getNoteActionDefinition(action)?.bucket === "production";
